import { useEffect, useState } from 'react';

export default function useMobile(): boolean {
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(`(max-width: 767px)`);

        const matcher = (event: MediaQueryListEvent) => setMobile(event.matches);

        if (media.addListener) {
            media.addListener(matcher);
        } else if (media.addEventListener) {
            media.addEventListener('change', matcher);
        }

        if (media?.matches) setMobile(true);

        return () => {
            if (media.removeListener) {
                media.removeListener(matcher);
            } else if (media.removeEventListener) {
                media.removeEventListener('change', matcher);
            }
        };
    }, []);

    return mobile;
}
